import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../models/models';

// Define el estado inicial como un objeto plano en lugar de una instancia de clase
const initialState: User = {
  id: '',
  name: '',
  email: '',
  acceptedTerms: false,
  createdAt: null,
  lastLogin: null,
  role: null,
  clientId: null,
  categories: []
};

const userDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUserData(state, action: PayloadAction<User>) {
      return { ...state, ...action.payload }; // Usar la propagación de objetos para mantener la inmutabilidad
    },
    // Puedes agregar otros reducers aquí si es necesario
  }
});

export const { setUserData } = userDataSlice.actions;

export default userDataSlice.reducer;
